import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ReceiverState {
  [aopNum: string]: { receiver: number };
}

const initialState: ReceiverState = {};

const receiverCountSlice = createSlice({
  name: 'receiverCount',
  initialState,
  reducers: {
    incrementReceiver(state, action: PayloadAction<string>) {
      const aopNum = action.payload;
      if (!state[aopNum]) {
        state[aopNum] = { receiver: 1 };
      } else {
        state[aopNum].receiver += 1;
      }
    },
    decrementReceiver(state, action: PayloadAction<string>) {
      const aopNum = action.payload;
      if (state[aopNum] && state[aopNum].receiver > 0) {
        state[aopNum].receiver -= 1;
      }
    },
    setReceiverValue(state, action: PayloadAction<{ aopNum: string; value: number }>) {
      const { aopNum, value } = action.payload;
      if (!state[aopNum]) {
        state[aopNum] = { receiver: Math.max(0, value) };
      } else {
        state[aopNum].receiver = Math.max(0, value);
      }
    },
    resetReceivers() {
      return initialState;
    },
  },
});

export const { incrementReceiver, decrementReceiver, resetReceivers, setReceiverValue } = receiverCountSlice.actions;
export default receiverCountSlice.reducer;
